import PropTypes from "prop-types";
import { Link as RouterLink } from "react-router-dom";
// material
import { alpha, styled } from "@mui/material/styles";
import {
  Box,
  Link,
  Card,
  Grid,
  Avatar,
  Typography,
  CardContent,
  Button,
  CircularProgress,
} from "@mui/material";
// utils
// import { fDate } from "../../../utils/formatTime";
// import { fShortenNumber } from "../../../utils/formatNumber";
//
import SvgIconStyle from "../../../components/SvgIconStyle";
import Iconify from "../../../components/Iconify";
import IconButton from "@mui/material/IconButton";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import React from "react";
import {
  documentFileUpload,
  setBannerUri,
  setProfileUri,
} from "../../../Containers/OnBoarding/slice";
import { useDispatch } from "react-redux";

// ----------------------------------------------------------------------

const CardMediaStyle = styled("div")({
  position: "relative",
  paddingTop: "calc(100% * 1 / 4)",
});

const TitleStyle = styled(Link)({
  height: 44,
  overflow: "hidden",
  WebkitLineClamp: 2,
  display: "-webkit-box",
  WebkitBoxOrient: "vertical",
});

const AvatarStyle = styled(Avatar)(({ theme }) => ({
  zIndex: 9,
  width: "88px",
  height: "88px",
  // position: "absolute",
  backgroundColor: theme.palette.primary.main,
  left: "6px",
  top: "6px",
 
  // bottom: theme.spacing(-2),
}));

const InfoStyle = styled("div")(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "flex-end",
  marginTop: theme.spacing(3),
  color: theme.palette.text.disabled,
}));

const CoverImgStyle = styled("img")({
  top: 0,
  width: "100%",
  height: "100%",
  objectFit: "cover",
  position: "absolute",
});

// ----------------------------------------------------------------------

BlogPostCard.propTypes = {
  post: PropTypes.object.isRequired,
  index: PropTypes.number,
};

export default function BlogPostCard({ post, index }) {
  const { cover, title, view, comment, share, author, createdAt } = post;
  const latestPostLarge = index === 0;
  const latestPost = index === 1 || index === 2;
  const [bannerPercentage, setBannerPercentage] = React.useState(0);
  const [profilePercentage, setProfilePercentage] = React.useState(0);
  const [profileUrl, setProfileUrl] = React.useState("");
  const dispatch = useDispatch();

  const POST_INFO = [
    { number: comment, icon: "eva:message-circle-fill" },
    { number: view, icon: "eva:eye-fill" },
    { number: share, icon: "eva:share-fill" },
  ];

  const onUploadProgress = (progressEvent) => {
    const { loaded, total } = progressEvent;
    let percent = Math.floor((loaded * 100) / total);
    if (percent < 100) {
      setBannerPercentage(percent);
    }
  };

  const onUploadProfileProgress = (progressEvent) => {
    const { loaded, total } = progressEvent;
    let percent = Math.floor((loaded * 100) / total);
    if (percent < 100) {
      setProfilePercentage(percent);
    }
  };

  const uploadBanner = React.useCallback((e) => {
    const data = new FormData();
    data.append("file", e.target.files[0]);
    dispatch(documentFileUpload({ data, onUploadProgress }))
      .unwrap()
      .then((res) => {
        dispatch(setBannerUri(res.fileName));
        setBannerPercentage(100);
        setTimeout(() => {
          setBannerPercentage(0);
        }, 1000);
      })
      .catch((error) => {
      });
  }, []);

  const uploadProfileImage = React.useCallback((e) => {
    const data = new FormData();
    data.append("file", e.target.files[0]);
    const onUploadProgress = onUploadProfileProgress;
    dispatch(documentFileUpload({ data, onUploadProgress }))
      .unwrap()
      .then((res) => {
        dispatch(setProfileUri(res.fileName));
        setProfileUrl(res.fileName);
        setProfilePercentage(100);
        setTimeout(() => {
          setProfilePercentage(0);
        }, 1000);
      })
      .catch((error) => {
      });
  }, []);

  return (
    <Card sx={{ position: "relative" }}>
      <CardMediaStyle
        sx={{
          ...((latestPostLarge || latestPost) && {
            pt: "calc(100% * 4 / 3)",
            "&:after": {
              top: 0,
              content: "''",
              width: "100%",
              height: "100%",
              position: "absolute",
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72),
            },
          }),
          ...(latestPostLarge && {
            pt: {
              xs: "calc(100% * 4 / 3)",
              sm: "calc(100% * 3 / 4.66)",
            },
          }),
        }}
      >
        {/* <SvgIconStyle
          color="paper"
          src="/static/icons/shape-avatar.svg"
          sx={{
            width: 80,
            height: 36,
            zIndex: 9,
            bottom: -15,
            position: "absolute",
            color: "background.paper",
            ...((latestPostLarge || latestPost) && { display: "none" }),
          }}
        /> */}

        <Box
          sx={{
            width: "100px",
            height: "100px",
            borderRadius: "50%",
            backgroundColor: "#fff",
            position: "absolute",
            top: "60%",
            left: "2%",
            zIndex: "1",
          }}
        >
          {" "}
          <AvatarStyle
            alt={author.name}
            src={author.avatarUrl}
            className="fotoperfil2"
            sx={{
              ...((latestPostLarge || latestPost) && {
                zIndex: 10,
                top: 24,
                left: 24,
                width: 40,
                height: 40,
                
                '& img':{
                  height:profileUrl.length > 0 ? '100%' : '50%',
                  width:profileUrl.length > 0 ? '100%' : '50%',
                }
              }),
            }}
          />
          <Box
            sx={{
              position: "absolute",
              top: "48%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "#212529b0 !important",
              borderRadius: profilePercentage > 0 ? "50%" : "20px",
              padding: profilePercentage > 0 ? "8px" : "0px",
              zIndex: 10,
            }}
          >
            {profilePercentage === 0 && (
              <Button
                aria-label="upload picture"
                component="label"
                sx={{
                  color: "#fff",
                  padding: "6px 8px !important",
                  fontWeight: 500,
                  textTransform: "none",
                  minWidth: 0,
                  "& .MuiButton-startIcon": {
                    margin: "0px !important",
                  },
                }}
                startIcon={<CloudUploadOutlinedIcon />}
              >
                <input
                  hidden
                  accept="image/png, image/jpg, image/jpeg"
                  type="file"
                  onChange={uploadProfileImage}
                />
              </Button>
            )}
            {profilePercentage > 0 && (
              <CircularProgress
                variant="determinate"
                value={profilePercentage}
              />
            )}
          </Box>
        </Box>
        <CoverImgStyle alt={title} src={cover} />
      </CardMediaStyle>

      <Box
        sx={{
          position: "absolute",
          top: "30%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "#212529 !important",
          borderRadius: bannerPercentage > 0 ? "50%" : "20px",
          display: "flex",
          padding: bannerPercentage > 0 ? "8px" : "0px",
        }}
      >
        {bannerPercentage === 0 && (
          <Button
            aria-label="upload picture"
            component="label"
            sx={{
              color: "#fff",
              padding: "6px 16px !important",
              fontWeight: 500,
              textTransform: "none",
            }}
            startIcon={<CloudUploadOutlinedIcon />}
          >
            <input
              hidden
              accept="image/png, image/jpg, image/jpeg"
              type="file"
              onChange={uploadBanner}
            />
            Definir a imagem do banner
          </Button>
        )}
        {bannerPercentage > 0 && (
          <CircularProgress variant="determinate" value={bannerPercentage} />
        )}
      </Box>

      <CardContent
        sx={{
          pt: 4,
          ...((latestPostLarge || latestPost) && {
            bottom: 0,
            width: "100%",
            position: "absolute",
          }),
        }}
      >
        {/* <Typography
          gutterBottom
          variant="caption"
          sx={{ color: "text.disabled", display: "block" }}
        >
          {/* {fDate(createdAt)} */}
        {/* </Typography> */}

        {/* <TitleStyle
          to="#"
          color="inherit"
          variant="subtitle2"
          underline="hover"
          component={RouterLink}
          sx={{
            ...(latestPostLarge && { typography: "h5", height: 60 }),
            ...((latestPostLarge || latestPost) && {
              color: "common.white",
            }),
          }}
        >
          {title}
        </TitleStyle> */}
      </CardContent>
    </Card>
  );
}
